// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { Fragment } from 'react';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { useIntl } from '@atlassian/jira-intl';
import { IssueCreateHomePageTrigger } from '@atlassian/jira-issue-create-home-page-trigger';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import messages from './messages';

const Header = () => {
	const { formatMessage } = useIntl();
	const { atlassianAccountId: accountId } = useTenantContext();

	if (!accountId) {
		return null;
	}

	return (
		<>
			<IssueCreateHomePageTrigger />
			<PageHeader truncateTitle>{formatMessage(messages.title)}</PageHeader>
		</>
	);
};

export default Header;
